import React from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import Breadcrumb from "../../components/breadcrumb";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import SignIn from "../../components/signin";

function Login(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      <MobileHeader handleMobile={handleMobile} />
      <NonLoginHeader clname="actPage9" handleMobile={handleMobile} />

      <div className="pt-70">
      <SignIn />
      <Gotop />
      </div>
    </>
  );
}

export default Login;
